import { useTranslation } from "react-i18next";
import { Box, IconButton, Link, Typography } from "@mui/material";
import {
  FacebookIcon,
  FooterLogo,
  InstagramIcon,
  LinkedInIcon,
  XIcon,
  YouTubeIcon,
} from "../../assets/icons/MUI/HomeIcons";

const styles = {
  footer: {
    background: "#101010",
  },
  container: {
    width: "90%",
    maxWidth: "1250px",
    margin: "0 auto",
    padding: "60px 0",
    display: "flex",
    flexDirection: "column",
  },
  topSection: {
    display: "flex",
    justifyContent: "space-between",
    paddingBottom: "25px",
    borderBottom: "1px solid #414141",
    marginBottom: "13px",
    rowGap: "33px",
    flexDirection: { xs: "column", md: "row" },
  },
  columnFlex: {
    display: "flex",
    flexDirection: "column",
    rowGap: "8px",
  },
  rowFlex: {
    display: "flex",
    columnGap: "75px",
    rowGap: "33px",
    flexDirection: { xs: "column", sm: "row" },
  },
  socialIcons: {
    display: "flex",
    columnGap: "9px",
  },
  iconButton: {
    background: "#008B07 !important",
  },
  bottomSection: {
    display: "flex",
    justifyContent: "space-between",
  },
  link: {
    color: "#FFF",
    fontFamily: "Montserrat",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "20px",
    textDecoration: "none",
  },
  footerSectionTitle: {
    color: "#FFF",
    fontFamily: "Montserrat",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "24px",
  },
  footerSectionLabel: {
    color: "#FFF",
    fontFamily: "Montserrat",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "20px",
  },
};

const FooterSection = ({ title, content }: { title: string; content: string }) => (
  <Box sx={styles.columnFlex}>
    <Typography sx={styles.footerSectionTitle}>{title}</Typography>
    <Typography sx={styles.footerSectionLabel}>{content}</Typography>
  </Box>
);

const SocialIcons = () => (
  <Box sx={styles.socialIcons}>
    {[InstagramIcon, YouTubeIcon, LinkedInIcon, FacebookIcon, XIcon].map((Icon, index) => (
      <IconButton key={index} sx={styles.iconButton}>
        <Icon />
      </IconButton>
    ))}
  </Box>
);

const HomeFooter = () => {
  const { t } = useTranslation();

  return (
    <Box component="footer" sx={styles.footer}>
      <Box sx={styles.container}>
        <Box sx={styles.topSection}>
          <Box sx={styles.rowFlex}>
            <FooterLogo />
            <FooterSection title={t("pages.home.address")} content={t("pages.home.addressDetails")} />
            <FooterSection title={t("pages.home.support")} content={t("pages.home.emailContact")} />
          </Box>
          <Box sx={styles.columnFlex}>
            <Typography sx={styles.footerSectionTitle}>{t("pages.home.followUs")}</Typography>
            <SocialIcons />
          </Box>
        </Box>
        <Box sx={styles.bottomSection}>
          <Typography sx={{ fontSize: "14px", fontWeight: 400, color: "#FFF" }}>{t("pages.home.year")}</Typography>
          <Box sx={{ display: "flex", columnGap: "40px" }}>
            <Link sx={styles.link}>{t("pages.home.contactUs")}</Link>
            <Link sx={styles.link}>{t("pages.home.privacyPolicy")}</Link>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default HomeFooter;
